import Swiper from "swiper";
import { Pagination, EffectCreative, Keyboard, Mousewheel, Navigation, Thumbs, EffectFade, Autoplay, EffectCoverflow, Grid, FreeMode } from "swiper/modules";

/**
 * @param swiperInit
 */
export default function swiperInit() {
    new Swiper(".section-home-banner .swiper", {
        modules: [Autoplay, Navigation, Pagination,],
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        effect: "fade",
        autoplay: {
            delay: 3500,
        },
        loop: true,
        navigation: {
            nextEl: ".section-home-banner .btn-next",
            prevEl: ".section-home-banner .btn-prev",
            clickable: true,
        },
        pagination: {
            el: ".section-home-banner .swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            576: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 1,
            },
        },
    });

    new Swiper(".slider-products .swiper", {
        modules: [Autoplay, Navigation, Pagination,],
        // slidesPerView: 5,
        spaceBetween: 12,
        speed: 1000,
        autoplay: {
            delay: 3500,
        },
        loop: true,
        navigation: {
            nextEl: ".slider-products .btn-next",
            prevEl: ".slider-products .btn-prev",
            clickable: true,
        },
        pagination: {
            el: ".slider-products .swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 5,
            },
        },
    });
    $('.slider-brand .swiper').each(function () {
        new Swiper(this, {
            modules: [Autoplay, Navigation, Pagination],
            spaceBetween: 24,
            speed: 1000,
            autoplay: {
                delay: 3500,
            },
            loop: true,
            pagination: {
                el: $(this).next('.slide-pagination-wrapper .swiper-pagination')[0],
                clickable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 2,
                },
                576: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 2,
                },
            },
        });
    })
    new Swiper(".slider-col-3 .swiper", {
        modules: [Autoplay, Navigation, Pagination,],
        spaceBetween: 40,
        speed: 1000,
        autoplay: {
            delay: 3500,
        },
        loop: true,
        navigation: {
            nextEl: ".slider-col-3 .btn-next",
            prevEl: ".slider-col-3 .btn-prev",
            clickable: true,
        },
        breakpoints: {
            576: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 3,
            },
        },
    });
    new Swiper(".slider-col-6 .swiper", {
        modules: [Autoplay, Navigation, Pagination,],
        spaceBetween: 32,
        speed: 1200,
        autoplay: {
            delay: 2000,
        },
        loop: true,
        breakpoints: {
            320: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 6,
            },
        },
    });
}

